<div class="dialog-header">
  <div class="header-title">
    <span class="header-span">{{preset.id ? 'Edit Preset' : 'New Preset'}}</span>
  </div>

  <div class="buttons-block">
    <button class="header-button report-button" mat-button (click)="delete()" *ngIf="preset.id" color="warn">
      <span>Delete</span>
    </button>

    <button class="header-button send-button" mat-button (click)="save()" [disabled]="!preset.title">
      <span>Save</span>
    </button>
  </div>

  <button mat-button class="close-button-container" disableRipple="true" (click)="close()">
    <mat-icon>clear</mat-icon>
  </button>
</div>

<div class="middle-content">
  <div class="inputs-block">
    <div class="input-block">
      <div class="input-label">Title:</div>
      <div class="email-input-text">
        <input class="arrow-input" type="text" pInputText [(ngModel)]="preset.title" placeholder="Preset Title">
      </div>
    </div>

    <div class="columns-list">
      <div *ngFor="let item of columnsSelection" class="column-checkbox-item" (click)="item.selected = !item.selected">
        <p-checkbox [binary]="true" [(ngModel)]="item.selected"></p-checkbox>
        <span class="item-label">{{item.column.name}}</span>
      </div>
    </div>
  </div>
</div>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

